import { List } from 'immutable'
import { listFromOption, loadingAsyncState } from 'widgets-for-react'
import { TypeCastingValidator, canSafelyCast } from '../../../../utils/safe-type-casting'
import { imageValidator } from '../../image/imageApi'
import { DishTeaserData } from './dishTeasersState'

export const dishTeaserValidator: TypeCastingValidator<DishTeaserData> = {
  kind: 'object',
  fieldsValidator: {
    Id: { kind: 'number' },
    HeaderTitle: { kind: 'string' },
    HeaderImage: imageValidator,
    Path: { kind: 'string' },
  },
}

export const loadDishTeasers = (apicall: () => Promise<any>) =>
  loadingAsyncState(() =>
    apicall().then((raw) =>
      Array.isArray(raw)
        ? {
            kind: 'result',
            value: List(raw)
              .map((v) => canSafelyCast<DishTeaserData>(dishTeaserValidator, v))
              .flatMap<DishTeaserData>(listFromOption)
              .toArray(),
            status: 200,
          }
        : {
            kind: 'failed',
            status: 404,
          }
    )
  )
